import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Customers} from '../../../_models/customers';
import { User } from '../../../_models/user';
import { Location } from '@angular/common';

import { FormValidator } from '../../../_helpers/form.validator';
import { CustomersValidator } from '../../customers.validator';

@Component({
  selector: 'app-customers-edit',
  templateUrl: './customers-edit.component.html'
})
export class CustomersEditComponent implements OnInit {

  title: string;
  subtitle: string;

  customersForm: FormGroup;

  actionModal: boolean;
  alertModal: boolean;
  infoModal: boolean;

  actionInfo: string;
  alertInfo: string;
  infoInfo: string;

  current_user_id: number;
  current_username: string;
  current_group_id: number;

  today: Date;

  // Variable para el control de las validaciones del formulario y sus mensajes.
  formValidator: FormValidator;


  @Input() customers: Customers;
  @Input() userList: User[];
  @Output() updateCustomers = new EventEmitter<Customers>();
  @Output() showInfoModal = new EventEmitter<{ value: boolean, info: string, link: string, skin: string }>();

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private _location: Location
  ) {
    this.formValidator = new FormValidator();
  }

  // convenience getter for easy access to form fields
  get f() { return this.customersForm.controls; }

  ngOnInit() {

    // {{ value_expression | sepa_date [ : format [ : timezone [ : locale ] ] ] }}
    // this.today = formatDate(new Date(), 'dd-MM-yyyy hh:mm:ss a', 'en-US', '+0200');
    this.today = new Date();

    this.current_user_id = Number(localStorage.getItem('user_id'));
    this.current_username = localStorage.getItem('username');
    this.current_group_id = Number(localStorage.getItem('group_id'));

    console.log('->->< Usuario actual logueado: ' + this.current_user_id + ' ;group_id = ' + this.current_group_id);
    console.log(this.current_username);

    if (this.customers.sepa_date === null) {
      this.customers.sepa_date = this.today;
    }

    this.customersForm = this.formBuilder.group({
      name: [this.customers.name, [Validators.maxLength(60)]],
      vat_reg: this.customers.vat_reg,
      postal_code: [this.customers.postal_code, [Validators.required, Validators.maxLength(10)]],
      addr1: this.customers.addr1,
      addr2: this.customers.addr2,
      city: [this.customers.city, [Validators.maxLength(60)]],
      province: [this.customers.province, [Validators.maxLength(60)]],
      country: [this.customers.country, [Validators.maxLength(60)]],
      tel: [this.customers.tel, [Validators.maxLength(24), Validators.minLength(9)]],
      email: [this.customers.email, [Validators.maxLength(120)]],
      annotation: this.customers.annotation,
      // delivery_route: [this.customers.delivery_route, Validators.maxLength(4)],
      user_id: this.customers.user_id,
      orig_id: -1, // [this.customers.orig_id, Validators.required],
      sepa_date: this.customers.sepa_date,
      // iban: this.customers.iban,
      // sepa: this.customers.sepa,
      // debt_past: this.customers.debt_past,
      // debt_fut: this.customers.debt_fut,
      // pay_past: this.customers.pay_past,
      // pay_fut: this.customers.pay_fut,
      // acc_nr: this.customers.acc_nr
    });

    // Asignamos los mensajes de error asociados a las validaciones que vamos a usar en el formulario.
    this.formValidator.setTemplateMessages(CustomersValidator.templateMessages);

    this.title = 'Módulo de Clientes';
    this.subtitle = 'Edición de Clientes';

    this.actionInfo = '¿Desea guardar el cliente?';

    this.infoInfo = 'La acción se ha realizado correctamente.';

    // Se crean las subscripciones para el control de los campos del formulario.
    this.formValidator.subscribeFormGroup(this.customersForm);

    if (this.customers.user_id === null || this.customers.user_id === undefined) {
      this.customersForm.controls.user_id.setValue(this.current_user_id);
    }
  } // End function OnInit

  selectDate(): void {
    console.log('---> Cambiando fecha:');
  }

  saveCustomers(): void {

    // NOTA: Se copian los cambios sobre la cliente inicial.
    const p = { ...this.customers, ...this.customersForm.value };

    this.updateCustomers.emit(p);

  } // End function saveCustomers

  changeUser(event: any): void {

    console.log('---> Cambiando Agente Comercial:');
    console.log(event);

  } // End function changeUser

  // ------------------------------------
  //    VALIDACIÓN FINAL DEL FORMULARIO
  // ------------------------------------

  validateCustomers(): void {

    // Se realizan las comprobaciones pertinentes para confirmar que los campos del formulario son correctos.

    if (this.customersForm.valid) {
      console.log('-------> Formulario customersForm correcto.');

      // Comprobaciones que no estén definidas ya en la declaración del formulario.
      if (this.customersForm.controls.name.value.trim() === '') {

        this.alertInfo = 'Debe de inscribir un nombre.';
        this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});

      } else {
        this.showActionModal(true);
      }
    } else {
      console.log('-------> Formulario customersForm NO válido:');
      console.log(this.customersForm);

      this.alertInfo = 'El formulario no está correctamente rellenado:<br>';

      if (this.customersForm.controls.email.value.trim() === '') {
        this.alertInfo += ' - Debe de inscribir un email y un nombre.<br>';
      }

      this.showInfoModal.emit({value: true, info: this.alertInfo, link: '', skin: 'alert'});
    }
  } // End function validateCustomers

  // ------- Función de regreso
  back(): void {
    // this._location.back();
    this.router.navigate(['/customers']);
  } // End function back

  // -----------------------------------------------
  //  FUNCIONES PARA EL CONTROL DE VENTANAS MODALES
  // -----------------------------------------------

  showActionModal(value: boolean) {
    this.actionModal = value;

  } // End function showActionModal

  confirmActionModal() {

    console.log('--> - -> Confirmada acción del modal.');

    this.saveCustomers();

    this.showActionModal(false);
  } // End function confirmActionModal

} // End Class CustomersEditComponent
